<template>
	<div :class="classList">
		{{ text }}
	</div>
</template>

<script>
export default {
	name: 'NotificationLabel',
	props: {
		level: {
			type: String,
			required: true,
			validator: _value => ['log', 'warning', 'dangerous', 'critical', 'success'].includes(_value)
		}
	},
	computed: {
		classList () {
			const { $style, level } = this
			return [
				$style.label,
				$style[`label--${level}`]
			]
		},
		text () {
			return this.$t('notifications.levels.' + this.level)
		}
	}
}
</script>
<style lang="scss" module>
.label {
    display: inline-flex;
    border-radius: 6px;
    font-size: 10px;
    font-weight: 600;
    padding: 4px 8px;
    text-transform: uppercase;
    line-height: 1;
    align-items: center;

    &--log {
        color: getColor(on-primary-container);
        background-color: getColor(primary-container);
    }

    &--warning {
        color: getColor(on-warning-container);
        background-color: getColor(warning-container);
    }

    &--dangerous,
    &--critical {
        color: getColor(on-error-container);
        background-color: getColor(error-container);
    }

    &--success {
        color: getColor(on-success-container);
        background-color: getColor(success-container);
    }
}
</style>
